// extracted by mini-css-extract-plugin
export var acitonButtons = "_hv-0";
export var additionalIcon = "_hv-f";
export var block = "_hv-1";
export var blockContent = "_hv-7";
export var blockDescription = "_hv-8";
export var blockIcon = "_hv-9";
export var blockTitle = "_hv-6";
export var border = "_hv-a";
export var center = "_hv-l";
export var edge = "_hv-b";
export var edgeLabel = "_hv-c";
export var edgePath = "_hv-d";
export var error = "_hv-e";
export var flowchart = "_hv-g";
export var flowchartContent = "_hv-h";
export var highlighted = "_hv-3";
export var hover = "_hv-4";
export var icon = "_hv-i";
export var left = "_hv-m";
export var navButton = "_hv-j";
export var navButtons = "_hv-k";
export var right = "_hv-n";
export var selected = "_hv-2";
export var small = "_hv-5";